import { useTranslation } from 'react-i18next';
import { SetPasswordPage } from './SetPasswordPage';

// Reached from the account-confirmation email link:
// /activeDirectory/confirmEmail?email=&emailToken=
export function ConfirmEmailPage() {
    const { t } = useTranslation();
    return (
        <SetPasswordPage
            endpoint="activeDirectory/changePassword"
            tokenParam="emailToken"
            emailKey="email"
            title={t('setPassword.confirmTitle')}
            subtitle={t('setPassword.confirmSubtitle')}
            submitLabel={t('setPassword.submitConfirm')}
        />
    );
}
